/**
 * Cart Page route
 */
import React from 'react';
import Layout from '@/components/Layout';
import Cart from '../../../containers/Cart';
import { useSetSSRStore, useSSRSelector } from '../../../redux';
import {getServerSideProps } from "src/pageUtils/getServerSideProps/cart";

export { getServerSideProps };

const CartPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <Layout
      store={storeInfo}
      title={`Cart - Now Shop Online`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGTitle={`Cart - Now Shop Online`}
      OGDescription={'Now order online from my whatsapp store & pay using 150+ UPI Apps'}
      isCustomDomain={props.isCustomDomain}
      OGImage={storeInfo?.store_info?.logo_image}
      {...props}
    >
      <Cart {...props} />
    </Layout>
  );
};

export default CartPage;
